import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IUser) {
    (function(Type) {
        Type["GUEST"] = "GUEST";
        Type["UNKNOWN"] = "UNKNOWN";
        Type["BRAND_USER"] = "BRAND_USER";
        Type["USER"] = "USER";
        Type["STYLIST"] = "STYLIST";
        Type["EDITOR"] = "EDITOR";
        Type["ADMIN"] = "ADMIN";
        Type["CONSUMER"] = "CONSUMER";
        Type["DEVELOPER"] = "DEVELOPER";
        Type["AUDITOR"] = "AUDITOR";
        Type["POTENTIAL_SIGN_UP_LEAD"] = "POTENTIAL_SIGN_UP_LEAD";
        Type["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    })(IUser.Type || (IUser.Type = {}));
    (function(EmailPreference) {
        /**
     * We should send emails of a certain type to the user.
     */ EmailPreference["OPTED_IN"] = "OPTED_IN";
        /**
     * We should not send emails of a certain type to the user.
     */ EmailPreference["OPTED_OUT"] = "OPTED_OUT";
        /**
     * The user has not decided on a preference, we should prompt them at a later time.
     */ EmailPreference["UNDECIDED"] = "UNDECIDED";
    })(IUser.EmailPreference || (IUser.EmailPreference = {}));
    IUser.build = function(partial) {
        return _object_spread({
            roles: [],
            addresses: [],
            instruments: [],
            capabilities: [],
            brand_tokens: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IUser || (IUser = {}));
export var IUser;
